/*
 * @Author: changcheng
 * @LastEditTime: 2023-06-12 09:36:11
 */
import React, { useEffect, FC, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logoImg from "@/assets/img/logo.jpg";
import { message } from "antd";
import { connect } from "react-redux";
import * as actions from "@/store/actions";
import QRCode from "@/assets/img/QRCode.png";
import "./index.less";
interface Props extends DefaultProps {
  routes?: any[];
  storeData?: any;
  setUserInfo: (params: any) => any;
  setNavIndex: (params: any) => any;
}
const pathMap: any = {
  "/index/home": 1,
  "/index/news": 1,
  "/index/subjectNavigation": 2,
  "/index/allTrain": 3,
  "/index/personCenter/onLineByCard": 4,
  "/index/personCenter/contactUs": 5,
  "/index/personCenter/learnRecord": 6,
};
const Header: FC<any> = ({ history, storeData, setNavIndex }) => {
  const { userInfo } = storeData;
  const [selectIndex, setSelectIndex] = useState<number>(1);
  const location = useLocation();
  useEffect(() => {
    setNavIndex({ navIndex: selectIndex });
  }, [selectIndex]);
  useEffect(() => {
    const pathname = location.pathname.split("?")[0];
    const pathIndex = pathMap[pathname] || 0;
    if (pathIndex) {
      setSelectIndex(pathIndex);
    } else {
      setSelectIndex(pathname.includes("personCenter") ? 6 : 1);
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className={"header-box"}>
      <div className={"header-content"}>
        <div className={"header-logo"}>
          <Link to="/index/home">
            <img src={logoImg} />
          </Link>
        </div>
        <div className={"header-menu"}>
          <span
            onClick={() => {
              setSelectIndex(1);
            }}
            className={selectIndex == 1 ? "active" : ""}
          >
            <Link to="/index/home">首&nbsp;&nbsp;页</Link>
          </span>
          <span
            onClick={() => {
              setSelectIndex(2);
            }}
            className={selectIndex == 2 ? "active" : ""}
          >
            <Link to="/index/subjectNavigation">学科导航</Link>
          </span>
          <span
            onClick={() => {
              if (userInfo) {
                setSelectIndex(3);
              } else {
                message.warning("请先登录");
              }
            }}
            className={selectIndex == 3 ? "active" : ""}
          >
            <Link
              to={
                userInfo ? "/index/allTrain" : location.pathname.split("?")[0]
              }
            >
              全员培训
            </Link>
          </span>
          {/* <span
            onClick={() => {
              if (userInfo) {
                setSelectIndex(4);
              } else {
                message.warning("请先登录");
              }
            }}
            className={selectIndex == 4 ? "active" : ""}
          >
            <Link
              to={
                userInfo
                  ? "/index/personCenter/onLineByCard"
                  : location.pathname.split("?")[0]
              }
            >
              在线购卡
            </Link>
          </span> */}
          <span
            onClick={() => {
              if (userInfo) {
                setSelectIndex(5);
              } else {
                message.warning("请先登录");
              }
            }}
            className={selectIndex == 5 ? "active" : ""}
          >
            <Link
              to={
                userInfo
                  ? "/index/personCenter/contactUs"
                  : location.pathname.split("?")[0]
              }
            >
              联系我们
            </Link>
          </span>
          <span
            onClick={() => {
              if (userInfo) {
                setSelectIndex(6);
              } else {
                message.warning("请先登录");
              }
            }}
            className={selectIndex == 6 ? "active" : ""}
          >
            <Link
              to={
                userInfo
                  ? "/index/personCenter/projectCollection"
                  : location.pathname.split("?")[0]
              }
            >
              个人中心
            </Link>
          </span>
        </div>
        <div className={"header-user"}>
          <img src={QRCode} alt="" />
          <div>
            <p>400-001-8080</p>
            <p>客服热线</p>
            <p>扫码下载app</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default connect((state) => state, actions)(Header);
